const setting = {
  path: 'setting/:merchantId',
  component: resolve => require(['../../../../../pages/admin/reviewed/setting'], resolve)
}

export default setting
